import GoogleTagManager from './GoogleTagManager';

export default GoogleTagManager;
